import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

/** Scoped DTO for PUT /users/settings/erp. Only allows toggling isActive (Enable/Disable sync). Provider is set by the backend on link(), not by the supplier. */
export const UpdateErpActiveDtoSchema = z
    .object({
        isActive: z.boolean({ required_error: 'isActive is required', invalid_type_error: 'isActive must be a boolean' }),
    })
    .strict();

export class UpdateErpActiveDto extends FromSchema(UpdateErpActiveDtoSchema) {
    isActive: boolean;
}
